export const ID = '3edebb74-1df3-47a8-b7e4-90ae052aa1e8';

export const NAME = 'Button: Simple';
